"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescriptionResetStyle = void 0;

var _styledComponents = require("styled-components");

/**
 * This style ensures that a content area does not have edge margins and adjusts
 * the elements inside for generic display as small companion descriptions
 */
var DescriptionResetStyle = (0, _styledComponents.css)(["ul,ol{list-style-position:inside;padding-left:0;}& > *:first-child{margin-top:0;}& > *:last-child{margin-bottom:0;}"]);
exports.DescriptionResetStyle = DescriptionResetStyle;